import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PaymentOptions = ({ caseId, lookupKey, priceLabel }) => {
  const [paypalClientId, setPaypalClientId] = useState(null);
  const [capturing, setCapturing] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/payments/paypal/config`);
        if (alive && data.client_id) setPaypalClientId(data.client_id);
      } catch (e) {
        // PayPal not configured yet
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (!paypalClientId) {
    return (
      <div
        data-testid="payment-options"
        className="w-full flex items-center justify-center gap-2 text-sm text-[#71717a] py-4"
      >
        <Loader2 size={16} className="animate-spin" />
        Loading secure PayPal checkout...
      </div>
    );
  }

  return (
    <div data-testid="payment-options">
      <div
        data-testid="pay-paypal-button"
        className={capturing ? "pointer-events-none opacity-60" : ""}
      >
        <PayPalScriptProvider
          options={{ clientId: paypalClientId, currency: "USD", intent: "capture" }}
        >
          <PayPalButtons
            style={{ layout: "vertical", color: "blue", shape: "pill", height: 48, label: "pay" }}
            forceReRender={[caseId, lookupKey]}
            createOrder={async () => {
              const { data } = await axios.post(`${API}/payments/paypal/orders`, {
                case_id: caseId,
                lookup_key: lookupKey,
                origin_url: window.location.origin,
              });
              return data.id;
            }}
            onApprove={async (data) => {
              setCapturing(true);
              try {
                await axios.post(`${API}/payments/paypal/orders/${data.orderID}/capture`);
                window.location.href = `/payment/success?case_id=${caseId}`;
              } catch (e) {
                toast.error(
                  "PayPal payment could not be confirmed. If you were charged, contact us."
                );
                setCapturing(false);
              }
            }}
            onError={() =>
              toast.error("PayPal ran into a problem. Please try again.")
            }
          />
        </PayPalScriptProvider>
      </div>
      {capturing && (
        <p className="text-center text-sm text-[#71717a] mt-3 flex items-center justify-center gap-2">
          <Loader2 size={14} className="animate-spin" />
          Confirming your {priceLabel} payment...
        </p>
      )}
    </div>
  );
};
